import React from 'react';

interface SVGAttributeProps extends React.SVGAttributes<HTMLOrSVGElement> {
  width?: number;
  height?: number;
}

const GoogleIcon = ({
  width = 24,
  height = 24,
  ...rest
}: SVGAttributeProps) => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={width}
      height={height}
      viewBox='0 0 24 24'
      fill='none'
      {...rest}
    >
      <path
        d='M19.7005 12.4867C19.7005 11.9907 19.6525 11.4787 19.5725 10.9987H12.6445V13.8307H16.6125C16.4525 14.7427 15.9245 15.5427 15.1405 16.0547L17.5085 17.8947C18.9005 16.5987 19.7005 14.7107 19.7005 12.4867Z'
        fill='#4280EF'
      />
      <path
        d='M12.6459 19.6547C14.6299 19.6547 16.2939 18.9987 17.5099 17.8787L15.1419 16.0547C14.4859 16.5027 13.6379 16.7587 12.6459 16.7587C10.7259 16.7587 9.10994 15.4627 8.51794 13.7347L6.08594 15.6067C7.33394 18.0867 9.86194 19.6547 12.6459 19.6547Z'
        fill='#34A353'
      />
      <path
        d='M8.51669 13.7188C8.21269 12.8068 8.21269 11.8148 8.51669 10.9028L6.08469 9.01477C5.04469 11.0948 5.04469 13.5428 6.08469 15.6068L8.51669 13.7188Z'
        fill='#F6B704'
      />
      <path
        d='M12.6459 7.87871C13.6859 7.86271 14.7099 8.26271 15.4619 8.98271L17.5579 6.87071C16.2299 5.62271 14.4699 4.95071 12.6459 4.96671C9.86194 4.96671 7.33394 6.53471 6.08594 9.01471L8.51794 10.9027C9.10994 9.15871 10.7259 7.87871 12.6459 7.87871Z'
        fill='#E54335'
      />
    </svg>
  );
};

export default GoogleIcon;
